<template>
  <div class="sysSetting">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
      </template>
    </crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        type="index"
        show-overflow-tooltip
        label="序号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="配置项"
      >
      </el-table-column>
      <el-table-column
        prop="code"
        label="配置码"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="settingEdit(scope.row)"
            >规则设置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 规则设置 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">规则设置</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="right"
            label-width="80px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="配置名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="配置状态" prop="status">
              <el-select
                v-model="addForm.status"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="开启" value="1"></el-option>
                <el-option label="关闭" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="金额" prop="price" v-show="addForm.id == 2">
              <el-input v-model="addForm.price" clearable></el-input>
            </el-form-item>

            <el-form-item label="配置" prop="value" v-if="addForm.type == 2">
              <upload
                @fileChange="uploadSortImg"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
              <img-view
                style="margin-left: 20px"
                :imgList="[{ url: sortImg, id: 0 }]"
              ></img-view>
            </el-form-item>
            <el-form-item label="配置" prop="value" v-else>
              <el-input v-model="addForm.value" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>金额转积分：下单金额赠送积分比例</p>
        <p>商城颜色：可切换PC商城主题色</p>
        <p>下单抽奖：下单满足设置金额赠送抽奖机会</p>
        <p>下单抽奖：下单满足设置金额赠送抽奖机会</p>
        <p>库存显示控制：超过设置阈值显示充裕，低于则显示实际库存</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "sysSetting",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**dialog */
      addDrawer: false,
      addForm: {
        id: "",
        configId: "",
        name: "",
        status: "1",
        price: "",
        value: "",
        type: "",
      },
      addFormRule: {
        name: [{ required: true, message: "请输入配置名称", trigger: "blur" }],
        status: [
          { required: true, message: "请输入配置状态", trigger: "blur" },
        ],
        value: [{ required: true, message: "请输入配置", trigger: "blur" }],
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**使用说明 */
      explain: false,
      sortImg: "", // 上传图片，用于本地显示
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData() {
      let data = {
        type: "PC_GetConfiguration",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Pc_Log"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        methods: "post",
        url:
          "configuration/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      }).then((res) => {
        this.allPage = res.recordCount;
        this.tableData = [];
        if (res.flag == 0) {
          res.data.forEach((item) => {
            this.tableData.push({
              id: item.Id,
              name: item.Name,
              code: item.TypeCode,
            });
          });
        }
      });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    // 编辑规则
    settingEdit(row) {
      this.clearForm();
      if (row) {
        let data = {
          type: "PC_GetConfigurationValue",
          id: row.id,
        };
        let proc = "Pc_Log"; // 存储过程名
        let type = "ReturnList";
        this.$requestSys({
          methods: "post",
          url:
            "configuration/ashx/ReturnJson.ashx?type=" +
            type +
            "&json=" +
            encodeURIComponent(JSON.stringify(data)) +
            "&proc=" +
            proc,
        }).then((res) => {
          if (res.flag == 0) {
            console.log(res, "获取配置线切割");
            this.addForm.id = res.data[0].Id;
            this.addForm.type = res.data[0].Type;
            this.addForm.configId = res.data[0].ConfigId;
            this.addForm.name = res.data[0].Name;
            this.addForm.status = res.data[0].Status;
            this.addForm.price = res.data[0].Money;
            this.addForm.value = res.data[0].Value;
            this.sortImg = this.$setImgUrl(res.data[0].Value);
            this.addDrawer = true;
          } else {
            this.$message({
              message: res.message || "获取配置详情失败",
              type: "error",
            });
          }
        });
      }
    },
    /**重置表单 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addForm.status = "1";
      this.addDrawer = false;
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "PC_AddConfigurationValue",
            id: this.addForm.id,
            ConfigId: this.addForm.configId,
            Status: this.addForm.status,
            Name: this.addForm.name,
            Money: this.addForm.price,
            Value: this.addForm.value,
          };
          let proc = "Pc_Log"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            methods: "post",
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    // 上传分类图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "/Management/FileAdmin/FileUpLoadApi",
          data: formData,
        })
          .then((res) => {
            if (res.success) {
              this.addForm.value = res.dataList[0].FileUrl;
              this.sortImg = this.$setImgUrl(res.dataList[0].FileUrl);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
.sysSetting {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
